<div class="app-transfer">
  <h1 class="app-transfer__title">Transferencia</h1>
  <div class="availability">
    <div class="availability__amount">
      <img alt="Icon wallet" src="/images/icons/atm-icon-solid-wallet.svg" />
      <span>Disponible:</span>
      <div *ngIf="loadingForm" class="skeleton"></div>
      <ng-container *ngIf="!loadingForm">
        <strong data-recording-sensitive>{{
          isServiceInterrupted
            ? '- -'
            : (model.availableBalance | hbCustomFormat: '$0,0.00')
        }}</strong>
      </ng-container>
    </div>
    <button
      class="availability__open-detail"
      [class.availability__open-detail--opened]="isBalanceVisible"
      (click)="toggleBalanceVisibility()"
    >
      <img src="/images/icons/atm-icn-open-arrow.svg" alt="open arrow" />
    </button>
  </div>
  <div
    class="availability-detail"
    [class.availability-detail--hidden]="!isBalanceVisible"
  >
    <div class="availability-detail__balance">
      <ng-container *ngFor="let item of cashList">
        <div class="row">
          {{ item.title }}
          <span data-recording-sensitive>{{
            item.cash
              | hbCustomFormat: (item.cash < 1 ? '$0,0.00[0]' : '$0,0.00')
          }}</span>
        </div>
      </ng-container>
    </div>
    <div class="availability-detail__description">
      <div class="availability-detail__description-title">
        ¿Cómo funciona?<span>El disponible para transferir dependerá de:</span>
      </div>
      <ul>
        <li>Si tienes operaciones pendientes</li>
        <li>
          La fecha de liquidación de tus instrumentos
          <span
            >Por ejemplo, si el lunes vendes un instrumento que liquida en 48
            horas, tendrás el dinero disponible para retirar el miércoles</span
          >
        </li>
      </ul>
    </div>
  </div>
  <div class="separator"></div>
  <form class="form" (ngSubmit)="onSubmit()" #tradeTransferForm="ngForm">
    <div
      class="form__items"
      [class.form__items--disabled]="loadingTransfer || loadingForm"
    >
      <div class="form__item">
        <div class="input input--read-only input--fluid">
          <label class="input__label">Estrategia origen</label>
          <input
            class="input__input input__input--prefilled"
            required
            disabled
            name="origin"
            [(ngModel)]="model.origin.name"
            #origin="ngModel"
            value="Origen"
          />
        </div>
      </div>
      <div class="form__item">
        <div
          class="input input--fluid"
          [class.input--read-only]="!allowDropdown"
        >
          <label class="input__label">{{
            destinationLabel | capitalize
          }}</label>
          <input
            *ngIf="!allowDropdown && model.destination"
            class="input__input input__input--prefilled"
            required
            disabled
            name="destination"
            [(ngModel)]="model.destination.name"
            #destination="ngModel"
            value="Origen"
          />
          <combo-select
            *ngIf="allowDropdown"
            class="combo-shadow"
            [resultsList]="transferAccounts$ | async"
            [title]="'Estrategia destino'"
            [sentSelected]="model.destination"
            (emitSelectedItem)="selectDestination($event)"
          ></combo-select>
        </div>
      </div>
      <div class="form__item">
        <hb-input-money
          label="Monto a transferir"
          [value]="model.amount"
          (valueChange)="setAmount($event)"
          placeholder="$0.00"
          prefix="$"
          [isError]="model.invalidAmount"
        >
          <ng-container *ngIf="model.invalidAmount">
            El monto que quieres transferir es mayor al disponible
          </ng-container>
        </hb-input-money>
      </div>
      <div class="form__item">
        <div class="information-card">
          <div class="information-card__container">
            <div
              class="information-card__leading-icon information-card__leading-icon--bell"
            ></div>
            <div *ngIf="!outOfService" class="information-card__information">
              Una vez que hagas una transferencia deberás esperar a que se
              realice para poder hacer otra
            </div>
            <div *ngIf="outOfService" class="information-card__information">
              Una vez que hagas una transferencia deberás esperar a que se
              realice para poder hacer otra,
              <strong>y se verá reflejada al siguiente día hábil</strong>.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form__item" *ngIf="isGeolocationEnabled">
      <button
        *ngIf="!loadingTransfer"
        type="submit"
        class="button button--small button--dark"
        [class.button--disabled]="!model.valid"
        [disabled]="!model.valid"
      >
        Transferir
      </button>
      <button
        *ngIf="loadingTransfer"
        class="button button--small button--dark button--loading button--disabled"
        disabled
      >
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </button>
    </div>
  </form>
</div>
